// extracted by mini-css-extract-plugin
export var caption = "UYmvX";
export var fullStars = "_38QoZ";
export var rating = "vVnK5";
export var root = "_1JA5M";